import { render, staticRenderFns } from "./goHot.vue?vue&type=template&id=d69fdefc&scoped=true&"
import script from "./goHot.vue?vue&type=script&lang=js&"
export * from "./goHot.vue?vue&type=script&lang=js&"
import style0 from "./goHot.vue?vue&type=style&index=0&id=d69fdefc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69fdefc",
  null
  
)

export default component.exports